import type { ApiRequestHelpers } from "./useHttpClient";
import type { OnboardingStatus, Response } from "~/types/api";

export function createOnboardingApi({ getRequest, postRequest }: ApiRequestHelpers) {
  const getOnboardingStatus = () => getRequest<Response<OnboardingStatus>>("/onboarding");

  const acknowledgeOnboardingField = (fieldKey: string) =>
    postRequest<Response<{ acknowledged: boolean }>>(`/onboarding/fields/${fieldKey}/acknowledge`, {});

  const confirmOnboarding = () => postRequest<Response<OnboardingStatus>>("/onboarding/confirm", {});

  return {
    getOnboardingStatus,
    acknowledgeOnboardingField,
    confirmOnboarding,
  };
}

export type OnboardingApi = ReturnType<typeof createOnboardingApi>;
